export enum AutomationTypeId {
  TechnicalReview = 'Technical Review',
  GridAggregation = 'Grid Aggregation',
  CompletenessReview = 'Completeness Review',
  PaymentReceived = 'Payment Received',
  CertificateCompletionReview = 'Certificate of Completion Review',
}
